import { render } from "./regalos_ingles.vue?vue&type=template&id=48c83fb7&scoped=true"
import script from "./regalos_ingles.vue?vue&type=script&lang=js"
export * from "./regalos_ingles.vue?vue&type=script&lang=js"

import "./regalos_ingles.vue?vue&type=style&index=0&id=48c83fb7&scoped=true&lang=css"
import "./regalos_ingles.vue?vue&type=style&index=1&id=48c83fb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c83fb7"]])

export default __exports__